import { Button, Form, Row, Col, Select, Checkbox } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import DataBreachService from '../../../../services/DataBreach.service';
import ModalFail from '../../../../components/Shared/modal/fail';
import ModalSuccess from '../../../../components/Shared/modal/success';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';

import { useEffect, useState, useRef } from 'react';
import IconBack from '../../../../assets/Images/icons/icon-back';
import UserService from '../../../../services/UserService';
import { ROUTER } from '../../../../constants/router';
import { useBlocker } from '../../../../util/usePrompt';
import useNotify from '../../../../context/Notification/useNotify';

const ResponsibilityForm = () => {
    const { t } = useTranslation('data-breach');
    const [form] = Form.useForm();
    let { id } = useParams();
    const notify = useNotify();
    const navigate = useNavigate();
    const [selectedReviewer, setSelectedReviewer] = useState([]);
    const [loadinSave, setLoadinSave] = useState(false);
    const [openModalStatus, setOpenModalStatus] = useState(undefined);
    const [responsibilityData, setResponsibilityData] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [editFlag, setEditFlag] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const [isChangeLocation, setIsChangeLocation] = useState();
    const [change, setChange] = useState(false);
    const [nextLocation, setNextLocation] = useState();
    const [groupFirstAction, setGroupFirstAction] = useState(['rejectRequest']);
    const [groupReviewer, setGroupReviewer] = useState([
        'viewAndEdit',
        'rejectRequest',
        'completeRequest',
    ]);
    const [groupOther, setGroupOther] = useState(['viewOnly']);
    const [changeEdit, setChangeEdit] = useState(false);
    const skipBlockerRef = useRef(false);

    const handleCheckboxChange = (group, setGroup, value, checked) => {
        let updatedGroup = [];

        if (value === 'viewOnly') {
            if (checked) {
                updatedGroup = ['viewOnly'];
            } else {
                updatedGroup = group.filter((item) => item !== 'viewOnly');
            }
        } else {
            updatedGroup = checked
                ? [...group.filter((item) => item !== 'viewOnly'), value]
                : group.filter((item) => item !== value);
        }

        setGroup(updatedGroup);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getResponsibilityDetail = async (value) => {
        try {
            const { data } = await DataBreachService.getResponsibilityDetail(
                value
            );
            if (data?.resultData) {
                setResponsibilityData(data?.resultData);
                if (data?.resultData) {
                    if (changeEdit) {
                        setViewMode(false);
                    } else {
                        data?.resultData?.firstAction.length !== 0 &&
                            setViewMode(true);
                    }
                }
                await setField(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getUser = async () => {
        try {
            const { data } = await DataBreachService.getUserList();
            if (data?.resultData) {
                setUserOptions(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const setField = async (resultData) => {
        if (!resultData) return;

        const mapResponsibilityGroup = (groupName) => {
            const group = resultData.responsibilityGroup.find(
                (g) => g.groupName === groupName
            );
            return group
                ? [
                    group.viewOnly && 'viewOnly',
                    group.viewEdit && 'viewAndEdit',
                    group.reject && 'rejectRequest',
                    group.complete && 'completeRequest',
                ].filter(Boolean)
                : [];
        };

        if (resultData.responsibilityGroup.length !== 0) {
            setGroupFirstAction(mapResponsibilityGroup('First Action'));
            setGroupReviewer(mapResponsibilityGroup('Reviewer'));
            setGroupOther(mapResponsibilityGroup('Other'));
        }
        const activeFirstAction = resultData.firstAction
            .filter((user) => user.status === 'ACTIVE')
            .map((user) => user.userId);
        const activeReviewers = resultData.reviewer
            .filter((user) => user.status === 'ACTIVE')
            .map((user) => user.userId);

        form.setFieldsValue({
            firstAction: activeFirstAction,
            reviewer: activeReviewers,
            groupFirstAction: mapResponsibilityGroup('First Action'),
            groupReviewer: mapResponsibilityGroup('Reviewer'),
            groupOther: mapResponsibilityGroup('Other'),
        });
        setSelectedReviewer(activeReviewers);
    };
    const preparePayload = (values, userOptions) => {
        const mapUsers = (userIds) => {
            return userIds.map((userId) => {
                const user = userOptions.find((u) => u.userId === userId);
                return {
                    userId: userId,
                    fullName: user?.fullName || '',
                };
            });
        };

        const prepareResponsibilityGroup = (
            groupName,
            groupValues,
            sequence
        ) => ({
            groupName,
            viewOnly: groupValues.includes('viewOnly'),
            viewEdit: groupValues.includes('viewAndEdit'),
            reject: groupValues.includes('rejectRequest'),
            complete: groupValues.includes('completeRequest'),
            sequence,
        });

        const payload = {
            dataBreachFormGroupId: id, // Add your dynamic ID here
            firstAction: mapUsers(values.firstAction || []),
            reviewer: mapUsers(values.reviewer || []),
            responsibilityGroup: [
                prepareResponsibilityGroup('First Action', groupFirstAction, 1),
                prepareResponsibilityGroup('Reviewer', groupReviewer, 2),
                prepareResponsibilityGroup('Other', groupOther, 3),
            ],
        };

        return payload;
    };

    const onFinish = (values) => {
        setLoadinSave(true);
        const payload = preparePayload(values, userOptions);
        if (responsibilityData.responsibilityGroup.length !== 0) {
            DataBreachService.updateResponsibility(payload)
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        setOpenModalStatus(true);
                    } else {
                        setOpenModalStatus(false);
                    }
                    setLoadinSave(false);
                    setChangeEdit(false);
                })
                .catch((err) => {
                    notify({
                        type: 'error',
                        title: t('Fail'),
                        description: t('FailedtoSubmitData'),
                        closeable: true,
                        timeOut: 120000,
                    });
                    setLoadinSave(false);
                });
        } else {
            DataBreachService.saveResponsibility(payload)
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        setOpenModalStatus(true);
                    } else {
                        setOpenModalStatus(false);
                    }
                    setLoadinSave(false);
                    setChangeEdit(false);
                })
                .catch((err) => {
                    // setOpenModalStatus(false);
                    setLoadinSave(false);
                    notify({
                        type: 'error',
                        title: t('Fail'),
                        description: t('FailedtoSubmitData'),
                        closeable: true,
                        timeOut: 120000,
                    });
                });
        }
        setEditFlag(false);
    };
    useBlocker((nextLocation) => {
        if (!skipBlockerRef.current) {
            onChangePage(nextLocation);
        }
    }, change === true && changeEdit === true);
    const onChangePage = (nextLocation) => {
        if (skipBlockerRef.current) return;
        setEditFlag(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        if (responsibilityData.responsibilityGroup.length === 0) {
            skipBlockerRef.current = true;
            await setEditFlag(false);
            await setChange(false);
            await setIsChangeLocation(false);
            await navigate(ROUTER.DATA_BREACH.RESPONSIBILITY);
            skipBlockerRef.current = false;
        } else {
            setEditFlag(false);
            setChange(false);
            setTimeout(() => {
                setField(responsibilityData);
            }, 0);
        }
    };

    const handelOkLocation = async () => {
        await setEditFlag(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };
    const changeViewMode = async () => {
        setEditFlag(false);
        setChangeEdit(true);
        setTimeout(() => {
            setField(responsibilityData);
        }, 0);
    };
    const keepEditing = async () => {
        setEditFlag(false);
        setViewMode(false);
    };

    const cancelForm = async () => {
        if (responsibilityData.responsibilityGroup.length !== 0) {
            if (change) {
                setEditFlag(true);
                setViewMode(true);
                setChangeEdit(false);
            } else {
                setViewMode(true);
                setChangeEdit(false);
            }
        } else {
            if (change) {
                setEditFlag(true);
                setViewMode(true);
                setChangeEdit(false);
            } else {
                await navigate(ROUTER.DATA_BREACH.RESPONSIBILITY);
            }
        }
    };
    const role = UserService.role()?.toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    useEffect(() => {
        if (!admin) {
            navigate(`/not-found`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [admin]);

    useEffect(() => {
        if (changeEdit) {
            getResponsibilityDetail(id);
            setViewMode(false);
        }
    }, [changeEdit]);

    useEffect(() => {
        getResponsibilityDetail(id);
        getUser();
    }, [id]);

    const isDisabled = (group, targetValue) => {
        if (viewMode) {
            return true;
        }
        return group.includes('viewOnly') && targetValue !== 'viewOnly';
    };

    return (
        <div className="bg-gray-body ">
            {/* <HeaderLayout /> */}

            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() =>
                        navigate(`${ROUTER.DATA_BREACH.RESPONSIBILITY}`)
                    }
                >
                    <IconBack />
                </div>
                {t('Edit Responsibility')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Data Breach')} / {t('Responsibility')} /
                </span>
                <span className="text-[#65707A]">
                    {' '}
                    {t('Edit Responsibility')}
                </span>
            </div>
            <div className="w-full m-auto">
                <div
                    className="content bg-white p-8 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="content pb-3">
                        <Form
                            scrollToFirstError={{
                                behavior: 'smooth',
                                block: 'center',
                            }}
                            onFinish={onFinish}
                            form={form}
                            className="w-full"
                            layout="vertical"
                            onFieldsChange={(_, allFields) => {
                                if (allFields.length > 0) {
                                    setChange(true);
                                }
                            }}
                        >
                            <Row>
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <div>
                                        <Row>
                                            <h3
                                                className="text-xl font-medium	"
                                                style={{ color: '#212121' }}
                                            >
                                                {t(
                                                    'Assign Responsibilities and Set Work Permissions'
                                                )}
                                            </h3>
                                        </Row>
                                        <Row>
                                            <p className="text-sm">
                                                {
                                                    responsibilityData.dataBreachFormName
                                                }
                                            </p>
                                        </Row>
                                    </div>
                                </Col>
                                <Col span={12} className="w-full">
                                    <Row>
                                        <Col span={24} className="w-full">
                                            <Row
                                                style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                }}
                                            >
                                                {viewMode ? (
                                                    <Button
                                                        size="large"
                                                        type="primary"
                                                        className="w-full"
                                                        onClick={() =>
                                                            changeViewMode()
                                                        }
                                                        style={{
                                                            width: 120,
                                                            marginRight: 20,
                                                        }}
                                                    >
                                                        {t('Edit')}
                                                    </Button>
                                                ) : (
                                                    <>
                                                        <Button
                                                            size="large"
                                                            htmlType="reset"
                                                            type="default"
                                                            className="text-purple-PHX border-purple-PHX w-full"
                                                            onClick={() =>
                                                                cancelForm()
                                                            }
                                                            style={{
                                                                width: 120,
                                                                marginRight: 20,
                                                            }}
                                                        >
                                                            {t('Cancel')}
                                                        </Button>
                                                        <Button
                                                            loading={loadinSave}
                                                            size="large"
                                                            htmlType="submit"
                                                            type="primary"
                                                            className="w-full"
                                                            style={{
                                                                width: 120,
                                                            }}
                                                        >
                                                            {t('Save')}
                                                        </Button>
                                                    </>
                                                )}
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {!responsibilityData.isManual && (
                                <>
                                    <div
                                        className="grid grid-cols-1 gap-10 border-purple-PHX border rounded-md p-5"
                                        style={{
                                            boxShadow:
                                                '0px 2px 12px 0px rgba(123, 103, 251, 0.2)',
                                        }}
                                    >
                                        <div className="">
                                            <p className="text-sm font-semibold">
                                                {t(
                                                    'The primary point of contact'
                                                )}
                                            </p>
                                            <ul className="list-disc">
                                                <li className="text-sm font-normal">
                                                    {t(
                                                        'This person receives an email notification when a data breach report is submitted'
                                                    )}
                                                </li>
                                            </ul>
                                            <Form.Item
                                                label={
                                                    <span className="text-sm font-normal">
                                                        {t(
                                                            'Select the Responsible Person'
                                                        )}
                                                    </span>
                                                }
                                                name="firstAction"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            t('requiredField'),
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    size="large"
                                                    mode="multiple"
                                                    placeholder={t(
                                                        'Select the Responsible Person'
                                                    )}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        (option?.children ?? '')
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                    disabled={viewMode}
                                                >
                                                    {userOptions.map((item) => (
                                                        <Select.Option
                                                            key={item.userId}
                                                            value={item.userId}
                                                        >
                                                            {item.fullName}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div
                                        className="grid grid-cols-1 gap-10 border-purple-PHX border rounded-md p-5 mt-4"
                                        style={{
                                            boxShadow:
                                                '0px 2px 12px 0px rgba(123, 103, 251, 0.2)',
                                        }}
                                    >
                                        <div className="">
                                            <p className="text-sm font-semibold">
                                                {t('Incident Reviewer')}
                                            </p>
                                            <ul className="list-disc">
                                                <li className="text-sm font-normal">
                                                    {t(
                                                        'This person is responsible for reviewing, tracking, updating information, and managing the incident until completion'
                                                    )}
                                                </li>
                                            </ul>
                                            <Form.Item
                                                label={
                                                    <span className="text-sm font-normal">
                                                        {t(
                                                            'Select the Responsible Person'
                                                        )}
                                                    </span>
                                                }
                                                name="reviewer"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            t('requiredField'),
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    size="large"
                                                    mode="multiple"
                                                    placeholder={t(
                                                        'Select the Responsible Person'
                                                    )}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        (option?.children ?? '')
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                    disabled={viewMode}
                                                    maxCount={3}
                                                    onChange={(
                                                        selectedValues
                                                    ) => {
                                                        if (
                                                            selectedValues.length <=
                                                            3
                                                        ) {
                                                            setSelectedReviewer(
                                                                selectedValues
                                                            );
                                                        }
                                                    }}
                                                >
                                                    {userOptions.map((item) => {
                                                        const isDisabled =
                                                        selectedReviewer.length >= 3 &&
                                                            !selectedReviewer.some((user) => user === item.userId);
                                                        return (
                                                            <Select.Option key={item.userId} value={item.userId} disabled={isDisabled}>
                                                                {item.fullName}
                                                            </Select.Option>
                                                        );
                                                    })}

                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div
                                className="grid grid-cols-1 gap-10 border-purple-PHX border rounded-md p-5 mt-4"
                                style={{
                                    boxShadow:
                                        '0px 2px 12px 0px rgba(123, 103, 251, 0.2)',
                                }}
                            >
                                <div className="">
                                    <p className="text-sm font-semibold">
                                        {t('Configure Access Permissions')}
                                    </p>

                                    <Row className="flex justify-between bg-[#F3F9FF]">
                                        <Col
                                            span={12}
                                            className="flex items-center"
                                        >
                                            <p className="text-sm font-semibold text-[#95A0A8] m-2">
                                                {t('User Group')}
                                            </p>
                                        </Col>
                                        <Col
                                            span={2}
                                            className="flex justify-center items-center"
                                        >
                                            <p className="text-sm font-semibold text-[#95A0A8] m-2">
                                                {t('View only')}
                                            </p>
                                        </Col>
                                        <Col
                                            span={2}
                                            className="flex justify-center items-center"
                                        >
                                            <p className="text-sm font-semibold text-[#95A0A8] m-2">
                                                {t('View and Edit')}
                                            </p>
                                        </Col>
                                        <Col
                                            span={2}
                                            className="flex justify-center items-center"
                                        >
                                            <p className="text-sm font-semibold text-[#95A0A8] m-2">
                                                {t('Reject Request')}
                                            </p>
                                        </Col>
                                        <Col
                                            span={2}
                                            className="flex justify-center items-center"
                                        >
                                            <p className="text-sm font-semibold text-[#95A0A8] m-2">
                                                {t('Complete Request')}
                                            </p>
                                        </Col>
                                    </Row>
                                    {!responsibilityData.isManual && (
                                        <Form.Item
                                            name="groupFirstAction"
                                            validateTrigger={[
                                                'onChange',
                                                'onSubmit',
                                            ]}
                                            rules={[
                                                {
                                                    validator: async (
                                                        _,
                                                        value
                                                    ) => {
                                                        if (
                                                            !groupFirstAction.length
                                                        ) {
                                                            throw new Error(
                                                                t(
                                                                    'Please choose at least 1 item'
                                                                )
                                                            );
                                                        }
                                                    },
                                                },
                                            ]}
                                            className="groupResponsiblity border border-b border-t-0 border-x-0 border-[#F3F6F9] py-2 mb-0"
                                        >
                                            <Row className="flex justify-between">
                                                <Col
                                                    span={12}
                                                    className="flex items-center"
                                                >
                                                    <p className="text-sm font-normal m-2 py-2">
                                                        {t(
                                                            'First action person'
                                                        )}
                                                    </p>
                                                </Col>
                                                <Col
                                                    span={2}
                                                    className="flex justify-center items-center"
                                                >
                                                    <Checkbox
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        // value="viewOnly"
                                                        checked={groupFirstAction.includes(
                                                            'viewOnly'
                                                        )}
                                                        disabled={isDisabled(
                                                            groupFirstAction,
                                                            'viewOnly'
                                                        )}
                                                        onChange={(e) => {
                                                            handleCheckboxChange(
                                                                groupFirstAction,
                                                                setGroupFirstAction,
                                                                'viewOnly',
                                                                e.target.checked
                                                            );
                                                            form.setFieldsValue(
                                                                {
                                                                    groupFirstAction,
                                                                }
                                                            );
                                                        }}
                                                    />
                                                </Col>
                                                <Col
                                                    span={2}
                                                    className="flex justify-center items-center"
                                                >
                                                    <Checkbox
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        checked={groupFirstAction.includes(
                                                            'viewAndEdit'
                                                        )}
                                                        disabled={isDisabled(
                                                            groupFirstAction,
                                                            'viewAndEdit'
                                                        )}
                                                        onChange={(e) => {
                                                            handleCheckboxChange(
                                                                groupFirstAction,
                                                                setGroupFirstAction,
                                                                'viewAndEdit',
                                                                e.target.checked
                                                            );
                                                            form.setFieldsValue(
                                                                {
                                                                    groupFirstAction,
                                                                }
                                                            );
                                                        }}
                                                    />
                                                </Col>
                                                <Col
                                                    span={2}
                                                    className="flex justify-center items-center"
                                                >
                                                    <Checkbox
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        // value="rejectRequest"
                                                        checked={groupFirstAction.includes(
                                                            'rejectRequest'
                                                        )}
                                                        disabled={isDisabled(
                                                            groupFirstAction,
                                                            'rejectRequest'
                                                        )}
                                                        onChange={(e) => {
                                                            handleCheckboxChange(
                                                                groupFirstAction,
                                                                setGroupFirstAction,
                                                                'rejectRequest',
                                                                e.target.checked
                                                            );
                                                            form.setFieldsValue(
                                                                {
                                                                    groupFirstAction,
                                                                }
                                                            );
                                                        }}
                                                    />
                                                </Col>
                                                <Col
                                                    span={2}
                                                    className="flex justify-center items-center"
                                                >
                                                    {/* <Checkbox value="completeRequest" style={{ lineHeight: '32px' }} disabled={viewMode || isViewOnlyCheckedFirstAction} /> */}
                                                    <Checkbox
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        // value="completeRequest"
                                                        checked={groupFirstAction.includes(
                                                            'completeRequest'
                                                        )}
                                                        disabled={isDisabled(
                                                            groupFirstAction,
                                                            'completeRequest'
                                                        )}
                                                        onChange={(e) => {
                                                            handleCheckboxChange(
                                                                groupFirstAction,
                                                                setGroupFirstAction,
                                                                'completeRequest',
                                                                e.target.checked
                                                            );
                                                            form.setFieldsValue(
                                                                {
                                                                    groupFirstAction,
                                                                }
                                                            );
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Form.Item>
                                    )}
                                    <Form.Item
                                        name="groupReviewer"
                                        validateTrigger={[
                                            'onChange',
                                            'onSubmit',
                                        ]}
                                        rules={[
                                            {
                                                validator: async (_, value) => {
                                                    if (!groupReviewer.length) {
                                                        throw new Error(
                                                            t(
                                                                'Please choose at least 1 item'
                                                            )
                                                        );
                                                    }
                                                },
                                            },
                                        ]}
                                        className="groupResponsiblity border border-b border-t-0 border-x-0 border-[#F3F6F9] py-2 mb-0"
                                    >
                                        <Row className="flex justify-between">
                                            <Col
                                                span={12}
                                                className="flex items-center"
                                            >
                                                <p className="text-sm font-normal m-2 py-2">
                                                    {t('Reviewer person')}
                                                </p>
                                            </Col>
                                            <Col
                                                span={2}
                                                className="flex justify-center items-center"
                                            >
                                                <Checkbox
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    // value="viewOnly"
                                                    checked={groupReviewer.includes(
                                                        'viewOnly'
                                                    )}
                                                    disabled={isDisabled(
                                                        groupReviewer,
                                                        'viewOnly'
                                                    )}
                                                    onChange={(e) => {
                                                        handleCheckboxChange(
                                                            groupReviewer,
                                                            setGroupReviewer,
                                                            'viewOnly',
                                                            e.target.checked
                                                        );
                                                        form.setFieldsValue({
                                                            groupReviewer,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                span={2}
                                                className="flex justify-center items-center"
                                            >
                                                {/* <Checkbox value="viewAndEdit" style={{ lineHeight: '32px' }} disabled={viewMode || isViewOnlyCheckedFirstAction} /> */}
                                                <Checkbox
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    // value="viewAndEdit"
                                                    checked={groupReviewer.includes(
                                                        'viewAndEdit'
                                                    )}
                                                    disabled={isDisabled(
                                                        groupReviewer,
                                                        'viewAndEdit'
                                                    )}
                                                    onChange={(e) => {
                                                        handleCheckboxChange(
                                                            groupReviewer,
                                                            setGroupReviewer,
                                                            'viewAndEdit',
                                                            e.target.checked
                                                        );
                                                        form.setFieldsValue({
                                                            groupReviewer,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                span={2}
                                                className="flex justify-center items-center"
                                            >
                                                <Checkbox
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    // value="rejectRequest"
                                                    checked={groupReviewer.includes(
                                                        'rejectRequest'
                                                    )}
                                                    disabled={isDisabled(
                                                        groupReviewer,
                                                        'rejectRequest'
                                                    )}
                                                    onChange={(e) => {
                                                        handleCheckboxChange(
                                                            groupReviewer,
                                                            setGroupReviewer,
                                                            'rejectRequest',
                                                            e.target.checked
                                                        );
                                                        form.setFieldsValue({
                                                            groupReviewer,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                span={2}
                                                className="flex justify-center items-center"
                                            >
                                                {/* <Checkbox value="completeRequest" style={{ lineHeight: '32px' }} disabled={viewMode || isViewOnlyCheckedFirstAction} /> */}
                                                <Checkbox
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    // value="completeRequest"
                                                    checked={groupReviewer.includes(
                                                        'completeRequest'
                                                    )}
                                                    disabled={isDisabled(
                                                        groupReviewer,
                                                        'completeRequest'
                                                    )}
                                                    onChange={(e) => {
                                                        handleCheckboxChange(
                                                            groupReviewer,
                                                            setGroupReviewer,
                                                            'completeRequest',
                                                            e.target.checked
                                                        );
                                                        form.setFieldsValue({
                                                            groupReviewer,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Form.Item>
                                    <Form.Item
                                        name="groupOther"
                                        validateTrigger={[
                                            'onChange',
                                            'onSubmit',
                                        ]}
                                        rules={[
                                            {
                                                validator: async (_, value) => {
                                                    if (!groupOther.length) {
                                                        throw new Error(
                                                            t(
                                                                'Please choose at least 1 item'
                                                            )
                                                        );
                                                    }
                                                },
                                            },
                                        ]}
                                        className="groupResponsiblity border border-b border-t-0 border-x-0 border-[#F3F6F9] py-2 mb-0"
                                    >
                                        <Row className="flex justify-between">
                                            <Col
                                                span={12}
                                                className="flex items-center"
                                            >
                                                <p className="text-sm font-normal m-2 py-2">
                                                    {t(
                                                        'Other Individuals Admin Beyond the Primary Contact and Incident Reviewer'
                                                    )}
                                                </p>
                                            </Col>
                                            <Col
                                                span={2}
                                                className="flex justify-center items-center"
                                            >
                                                <Checkbox
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    // value="viewOnly"
                                                    checked={groupOther.includes(
                                                        'viewOnly'
                                                    )}
                                                    disabled={isDisabled(
                                                        groupOther,
                                                        'viewOnly'
                                                    )}
                                                    onChange={(e) => {
                                                        handleCheckboxChange(
                                                            groupOther,
                                                            setGroupOther,
                                                            'viewOnly',
                                                            e.target.checked
                                                        );
                                                        form.setFieldsValue({
                                                            groupOther,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                span={2}
                                                className="flex justify-center items-center"
                                            >
                                                {/* <Checkbox value="viewAndEdit" style={{ lineHeight: '32px' }} disabled={viewMode || isViewOnlyCheckedFirstAction} /> */}
                                                <Checkbox
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    // value="viewAndEdit"
                                                    checked={groupOther.includes(
                                                        'viewAndEdit'
                                                    )}
                                                    disabled={isDisabled(
                                                        groupOther,
                                                        'viewAndEdit'
                                                    )}
                                                    onChange={(e) => {
                                                        handleCheckboxChange(
                                                            groupOther,
                                                            setGroupOther,
                                                            'viewAndEdit',
                                                            e.target.checked
                                                        );
                                                        form.setFieldsValue({
                                                            groupOther,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                span={2}
                                                className="flex justify-center items-center"
                                            >
                                                <Checkbox
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    // value="rejectRequest"
                                                    checked={groupOther.includes(
                                                        'rejectRequest'
                                                    )}
                                                    disabled={isDisabled(
                                                        groupOther,
                                                        'rejectRequest'
                                                    )}
                                                    onChange={(e) => {
                                                        handleCheckboxChange(
                                                            groupOther,
                                                            setGroupOther,
                                                            'rejectRequest',
                                                            e.target.checked
                                                        );
                                                        form.setFieldsValue({
                                                            groupOther,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                span={2}
                                                className="flex justify-center items-center"
                                            >
                                                {/* <Checkbox value="completeRequest" style={{ lineHeight: '32px' }} disabled={viewMode || isViewOnlyCheckedFirstAction} /> */}
                                                <Checkbox
                                                    style={{
                                                        lineHeight: '32px',
                                                    }}
                                                    // value="completeRequest"
                                                    checked={groupOther.includes(
                                                        'completeRequest'
                                                    )}
                                                    disabled={isDisabled(
                                                        groupOther,
                                                        'completeRequest'
                                                    )}
                                                    onChange={(e) => {
                                                        handleCheckboxChange(
                                                            groupOther,
                                                            setGroupOther,
                                                            'completeRequest',
                                                            e.target.checked
                                                        );
                                                        form.setFieldsValue({
                                                            groupOther,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Form.Item>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
            {openModalStatus && (
                <ModalSuccess
                    open={openModalStatus}
                    handelClose={async () => {
                        setOpenModalStatus(undefined);
                        setEditFlag(false);
                        await setViewMode(true);
                    }}
                    handelOk={async () => {
                        setOpenModalStatus(undefined);
                        setEditFlag(false);
                        await setViewMode(true);
                    }}
                    text={t('Successfully saved data')}
                />
            )}
            <ModalFail
                open={openModalStatus === false}
                handelClose={() => {
                    setOpenModalStatus(undefined);
                }}
                handelOk={() => {
                    setOpenModalStatus(undefined);
                }}
                text={t('Failed to submit data')}
            />
            <ModalDiscardChanges
                open={editFlag}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => keepEditing()}
            />
        </div>
    );
};

export default ResponsibilityForm;
